import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import "./features/Styles/index.scss";
import registerServiceWorker from "./registerServiceWorker";
import './utils/datetime'

ReactDOM.render(<App />, document.getElementById("root") as HTMLElement);
registerServiceWorker();
